export default __webpack_public_path__ + "static/media/designbg.27243424.jpeg";